import type { Problem } from '@pickpro/contracts';

export class ApiError extends Error {
  constructor(public readonly problem: Problem) {
    super(problem.messageKey);
    this.name = 'ApiError';
  }

  get status(): number {
    return this.problem.status;
  }
}

export const isApiError = (error: unknown): error is ApiError => error instanceof ApiError;
